export default __webpack_public_path__ + "cf4d02a8df47af3d279cfefb31fdba51.png";